import { render, staticRenderFns } from "./QuestionReport.vue?vue&type=template&id=4cffbfb9&scoped=true&"
import script from "./QuestionReport.vue?vue&type=script&lang=js&"
export * from "./QuestionReport.vue?vue&type=script&lang=js&"
import style0 from "./QuestionReport.vue?vue&type=style&index=0&id=4cffbfb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cffbfb9",
  null
  
)

export default component.exports